import { SR_API_ACTION_LISTING_REQUEST_ONLINE_APP } from 'api/actionTypes';

import getApplicationsAction from 'client/actions/Household/getApplications';

export default async function requestOnlineApp({ state, apiClient }, { listingId }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_LISTING_REQUEST_ONLINE_APP,
    state: state,
    payload: {
      listingId,
    },
  });
  await getApplicationsAction(
    { state, apiClient },
    {
      userId: state.get(['currentUser', 'id']),
    },
  );
}
